import { render } from "./answerList.vue?vue&type=template&id=82aa3096&scoped=true"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"

import "./answerList.vue?vue&type=style&index=0&id=82aa3096&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82aa3096"]])

export default __exports__